import { useTranslation } from 'react-i18next';
import * as emailjs from "@emailjs/browser";
import {useEffect, useState} from "react";
import { useRef } from 'react';

function Contact() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)

    emailjs.send("service_hcps28n", "template_5dtle9t", {
      full_name: e.target.name?.value,
      email_address: e.target.email?.value,
      message: e.target.message?.value,
      email_to: 'michalwierzbicki.miw@gmail.com'
    })
        .then(function(response) {
          formRef.current.reset();
          setLoading(false)
        }, function(_error) {
          setLoading(false)
        })
  };

  useEffect(() => {
    emailjs.init({
      publicKey: 'Bw1PBYjGz25HZ6IAi',
      blockHeadless: true,
      limitRate: {
        id: 'app',
        throttle: 10000,
      },
    })
  }, [])

  return (
    <section id="contact" className="section contact-section">
      <div className="contact-card">
        <div>
          <div className="eyebrow">{t('contact.eyebrow')}</div>
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.description')}</p>
        </div>

        <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
          <label>
            {t('contact.name')}
            <input type="text" name="name" placeholder={t('contact.namePlaceholder')} />
          </label>

          <label>
            {t('contact.email')}
            <input type="email" name="email" placeholder={t('contact.emailPlaceholder')} />
          </label>

          <label>
            {t('contact.message')}
            <textarea
              name="message"
              rows="4"
              placeholder={t('contact.messagePlaceholder')}
            ></textarea>
          </label>

          <button type="submit" className="button primary" disabled={loading}>
            {loading ? t('contact.sending') : t('contact.submit')}
          </button>
        </form>
      </div>
    </section>
  );
}

export default Contact;
